interface AssignedProsecutorHistoryProps {
  data: any[];
}

export default function AssignedProsecutorHistory({
  data = [],
}: AssignedProsecutorHistoryProps) {
  return (
    <div className="bg-white rounded-xl p-5 shadow-sm space-y-4">
      <h3 className="text-base font-semibold text-gray-800 border-b pb-3">
        Assigned Prosecutor History
      </h3>

      {data
        ?.filter((obj) => obj?.assignedTo)
        ?.map((obj: any) => (
          <div className="relative bg-gray-500 rounded-md p-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <img
                  src={require("../../../images/avatar.png")}
                  alt="avatar"
                  className="w-8 h-8 rounded-full"
                />
                <div>
                  <p className="font-medium text-white text-sm">
                    {obj?.assignedTo || "-"}
                  </p>
                  <p className="text-xs text-gray-300">
                    Assigned Date: {obj?.assignedDate || "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}
